import createPage from '../create-page'
import Item from '../item-page/item'

export default createPage(Item, 'SUBCOLLECTION', true)



// WEBPACK FOOTER //
// ./src/components/item-sub-page/index.js